import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { EmpresaLogoPicker, EmpresaDadosFields, EmpresaBrandingFields } from "./EmpresaFormDados";
import { EmpresaValidacaoSection, EmpresaLicencaSection, EmpresaRastreamentoSection, EmpresaBackupRegiaoSection } from "./EmpresaFormConfig";

// Dialog Nova/Editar Empresa — recebe o estado de `useEmpresaForm`.
export function EmpresaFormDialog({ form }) {
  const { open, editing, f, set, logoRef, close, save, uploadLogo } = form;
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) close(); }}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader><DialogTitle>{editing ? "Editar Empresa" : "Nova Empresa"}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <EmpresaLogoPicker f={f} set={set} logoRef={logoRef} onUpload={uploadLogo} />
          <div className="grid md:grid-cols-2 gap-3">
            <EmpresaDadosFields f={f} set={set} />
            <EmpresaBrandingFields f={f} set={set} />
            <EmpresaValidacaoSection f={f} set={set} />
            <EmpresaLicencaSection f={f} set={set} editing={editing} />
            <EmpresaRastreamentoSection f={f} set={set} />
            <EmpresaBackupRegiaoSection f={f} set={set} />
          </div>
          <Button onClick={save} className="w-full bg-orange-600 hover:bg-orange-700" data-testid="btn-save-empresa">
            {editing ? "Salvar Alterações" : "Criar Empresa"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
